import { useEffect, useRef } from 'react';
import { useSupportContent } from '../../content/sections/support.js';
import type { ChatMessage as ChatMessageType } from '../../stores/chat-store.js';
import { ChatMessage } from './chat-message.js';

/* Lista de mensagens com auto-scroll só quando o usuário já está perto do fim
   (não interrompe leitura de histórico — armadilha do esboço). */
export function ChatThread({ messages }: { readonly messages: readonly ChatMessageType[] }) {
  const copy = useSupportContent();
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (el === null || messages.length === 0) return;
    const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 120;
    if (nearBottom) el.scrollTop = el.scrollHeight;
  }, [messages]);

  if (messages.length === 0) {
    return (
      <div className="grid min-w-0 flex-1 place-items-center text-sm text-muted-foreground">
        {copy.chatThread.empty}
      </div>
    );
  }
  return (
    <div ref={ref} className="min-w-0 flex-1 space-y-3 overflow-y-auto p-4">
      {messages.map((message) => (
        <ChatMessage key={message.id} message={message} />
      ))}
    </div>
  );
}
